/**
 * LoadingButton Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Button, { ButtonProps } from '../../../atoms/buttons/Button';
import LoadingIndicator from '../../../atoms/feedback/LoadingIndicator';

export interface ILoadingButtonProps extends ButtonProps {
  buttonClassName?: string;
  isLoading: boolean;
  loadingIndicatorClassName?: string;
  onLoad?<R = any>(): R | void;
}

interface IOwnState {
  isLoading: boolean;
}

const classes = new BEM('loading-button');

export default class LoadingButton extends React.Component<ILoadingButtonProps, IOwnState> {
  static getDerivedStateFromProps({ isLoading }: ILoadingButtonProps, prevState: IOwnState) {
    if (isLoading !== prevState.isLoading) {
      return { isLoading };
    }

    return null;
  }

  private onLoadTimer: number;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  componentDidUpdate(_, prevState: IOwnState) {
    if (this.state.isLoading && !!!prevState.isLoading && this.props.onLoad) {
      this.onLoadTimer = window.setTimeout(this.props.onLoad, 350);
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.onLoadTimer);
  }

  onClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }

    if (this.props.isLoading === undefined && this.props.onLoad) {
      this.props.onLoad();
    }
  }

  render() {
    const {
      buttonClassName,
      className,
      isLoading,
      loadingIndicatorClassName,
      onClick,
      onLoad,
      ...buttonProps
    } = this.props;

    const classModifiers = {
      'is-loading': this.state.isLoading,
    };

    return (
      <div {...classes('', classModifiers, className) }>
        <LoadingIndicator
          className={loadingIndicatorClassName}
        />
        <Button
          onClick={this.onClick}
          className={buttonClassName}
          {...buttonProps}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/buttons/LoadingButton/index.tsx